module.exports = __webpack_public_path__ + "static/media/ngtv.e5ba4ec5.mp4";